
import { defineComponent, ref, reactive } from 'vue'
import QForm from 'quasar/src/components/form/QForm.js';
import { useFormModule } from '@/modules/_shared/forms'
import { AddSSOJoinRule, useSSOJoinRulesModule } from '@/modules/sso-join-rules'
import { useRoute, useRouter } from 'vue-router'
import { SSOJoinRulesRouteNames } from '@/router/routes-names'
import SsoJoinRulesFormFieldDomain from '@/components/sso-join-rules/form-fields/domain.vue'
import SsoJoinRuleFormFieldDepartment from '@/components/sso-join-rules/form-fields/department.vue'
import SsoJoinRuleFormFieldCompanyName from '@/components/sso-join-rules/form-fields/company-name.vue'
import SsoJoinRuleFormFieldOrganization from '@/components/sso-join-rules/form-fields/organization.vue'
import SsoJoinRuleFormFieldAgreement from '@/components/sso-join-rules/form-fields/agreement.vue'
import InfoAboutCompanyNameAndDepartment from '@/components/sso-join-rules/info-about-company-name-and-department.vue'
import SsoJoinRuleFormFieldGroups from '@/components/sso-join-rules/form-fields/groups.vue'

export default defineComponent({
    name: 'sso-join-rules-new-join-rule',
    components: {
        InfoAboutCompanyNameAndDepartment,
        SsoJoinRulesFormFieldDomain,
        SsoJoinRuleFormFieldDepartment,
        SsoJoinRuleFormFieldCompanyName,
        SsoJoinRuleFormFieldOrganization,
        SsoJoinRuleFormFieldAgreement,
        SsoJoinRuleFormFieldGroups
    },
    async setup () {
        const router = useRouter()
        const route = useRoute()
        const { submitForm, createOnSuccess } = useFormModule()
        const { addSSOJoinRule } = useSSOJoinRulesModule()

        const form = ref<QForm>()
        const ssoJoinRuleModel = reactive<AddSSOJoinRule>({
            organizationId: '',
            agreementId: '',
            domain: '',
            department: '',
            companyName: '',
            groups: ''
        })

        const sendRequest = async () => addSSOJoinRule(ssoJoinRuleModel)
        const moveToList = () => router.push({ name: SSOJoinRulesRouteNames.LIST, query: { page: route.query.page } })

        const onSubmit = () => submitForm(
            form.value,
            sendRequest,
            createOnSuccess('SSO join rule added!')
        ).then(moveToList)

        return {
            form,
            onSubmit,
            ssoJoinRuleModel,
            SSOJoinRulesRouteNames,
            route
        }
    }
})
